module.exports = __webpack_public_path__ + "img/head-side.0f091c89.svg";